<template>
  <v-dialog v-model="localValue" width="700px">
    <v-card>
      <v-card-title>
        <span>Sobrescrever template de e-mail</span>
        <v-spacer />
        <mf-search v-model="search" hide-details placeholder="Buscar template" autofocus />
      </v-card-title>
      <v-card-text class="pb-0">
        <list-builder-templates ref="listBuilderTemplates" :search="search" :selectedTemplate.sync="selectedTemplate" />
      </v-card-text>
      <v-card-actions>
        <mf-action-buttons
          class="pb-1"
          :primary-button="{
            text: 'Sobrescrever template',
            action: createEmailTemplate,
            isDisabled: !selectedTemplate,
            isVisible: true,
            isLoading: loadingCreatingTemplate,
          }"
          :secondary-button="{
            text: 'Cancelar',
            action: close,
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MUTATE_UPSERT_TEMPLATE } from '@/modules/campanhas/campanhas-email/graphql'

export default {
  components: {
    ListBuilderTemplates: () => import('@/modules/campanhas/campanhas-email/views/components/builder-templates/ListBuilderTemplates.vue'),
  },
  props: {
    value: {
      type: Boolean,
    },
    templateGetter: {
      type: Function,
      required: true,
    },
  },

  data: () => ({
    lazyValue: false,
    loadingCreatingTemplate: false,
    selectedTemplate: null,
    search: '',
  }),

  computed: {
    localValue: {
      get() {
        return this.lazyValue
      },
      set(value) {
        this.lazyValue = value
        this.$emit('input', value)
      },
    },
  },

  watch: {
    value(value) {
      this.lazyValue = value
      if (value) {
        this.selectedTemplate = null
        this.reset()
      }
    },
  },

  mounted() {
    this.lazyValue = this.value
  },

  methods: {
    async createEmailTemplate() {
      const configuration = await this.templateGetter()
      try {
        this.loadingCreatingTemplate = true
        await this.$apollo.mutate({
          mutation: MUTATE_UPSERT_TEMPLATE,
          variables: {
            data: {
              _id: this.selectedTemplate._id,
              title: this.selectedTemplate.title,
              configuration: configuration,
            },
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
        })
        this.$snackbar({ message: 'Template de e-mail sobrescrito com sucesso.', snackbarColor: 'success' })
        this.$refs.listBuilderTemplates.refresh()
        this.localValue = false
      } catch (e) {
        console.warn(e)
        this.$snackbar({ message: 'Falha ao sobrescrever o template de e-mail.', snackbarColor: 'error' })
      } finally {
        this.loadingCreatingTemplate = false
      }
    },
    close() {
      this.localValue = false
    },
    reset() {
      this.search = ''
      if (this.$refs.listBuilderTemplates) {
        this.$refs.listBuilderTemplates.refresh()
      }
    },
  },
}
</script>
